export default __webpack_public_path__ + "static/media/Website-Passcode-Banner.ad2b43f1.jpg";